export const ANONYMOUS_ID = -999;
export const ANONYMOUS_GUID = "ffffffff-ffff-ffff-ffff-ffffffffffff";
